import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
import React from 'react'

interface Props {
  backgroundColor: string
  builderImage: any
  imageAltText: string
  recipeName: string
  recipeDescription: string
  autoHeight: boolean
  bestseller: boolean
  columns: number
  minHeight: string
}

const RecipeCard = ({
  backgroundColor,
  builderImage,
  imageAltText,
  recipeName,
  recipeDescription,
  autoHeight,
  bestseller,
  columns,
  minHeight
}: Props) => {
  const renderImage = () => {
    return (
      <>
        {builderImage && (
          <CdnImage
            className="index-2 relative w-11/12 mx-auto object-contain rounded-t-3xl mt-2"
            url={builderImage}
            alt={imageAltText}
            steps={[1080]}
            width={'500'}
          />
        )}
      </>
    )
  }
  return (
    <div
      className={`flex h-full flex-col justify-between text-center ${columns === 1 ? 'max-w-[320px] lg:max-w-[420px]' : ''}`}
    >
      <div className="flex h-full flex-col">
        <div className="block grid-cols-3 md:grid md:grid-cols-1 flex-grow">
          <div className="relative mx-auto w-full overflow-hidden md:rounded-none md:h-auto">{renderImage()}</div>
          {bestseller && (
            <span
              style={{ lineHeight: '1rem', right: '0.5rem' }}
              className="absolute top-[15%] inline-flex h-11 w-11 -rotate-12 items-center justify-center rounded-full bg-healthBG text-center text-[0.65rem] text-healthText drop-shadow md:h-20 md:w-20 md:text-[1rem] xl:inline-flex"
            >
              Popular
            </span>
          )}

          <div
            className={`col-span-2 flex ${autoHeight ? '!h-auto' : 'h-auto min-h-[37rem] xs:min-h-[26rem] sm:min-h-[17rem] lg:min-h-[24rem] 2xl:min-h-[14rem]'}  flex-col p-4 rounded-b-3xl w-11/12 mx-auto`}
            style={{ backgroundColor, minHeight: minHeight }}
          >
            <h4 className="mb-0 md:mb-2 text-center md:text-xl font-sans font-semibold">{recipeName}</h4>

            <p
              className="mt-4 flex lg:h-full flex-grow flex-col text-center px-2 lg:px-4 pb-4 lg:pb-0"
              dangerouslySetInnerHTML={{ __html: recipeDescription }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default RecipeCard

Builder.registerComponent(RecipeCard, {
  name: 'RecipeCard',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#f9f5f1'
    },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'recipeName',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'recipeDescription',
      type: 'richText',
      defaultValue: ''
    },

    {
      name: 'autoHeight',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'bestseller',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'columns',
      type: 'number',
      defaultValue: 2
    },
    {
      name: 'minHeight',
      type: 'text',
      defaultValue: ''
    }
  ]
})
